import { apiAxios } from './Axios'
import { auth } from '../firebase'

/**
 * Permanently delete the signed-in user's Auth account and Firestore data.
 * Requires a valid ID token (sent as Bearer).
 */
export async function deleteAccount() {
  const currentUser = auth.currentUser
  if (!currentUser) {
    throw new Error('Not signed in')
  }

  const idToken = await currentUser.getIdToken()
  return apiAxios.post(
    'deleteAccount',
    null,
    { headers: { Authorization: `Bearer ${idToken}` } }
  )
}
